import React, { Fragment, useEffect, useState } from "react";
import { ROUTES } from "../../constants/routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../components/UI/loadingSpinner/LoadingSpinner";
import { Link } from "react-router-dom";
import { getApi } from "../../services/http.service";
import moment from "moment";
import { Icon } from "@iconify/react";
import { IShop } from "../../interfaces/shop.interface";
import VisibilityBox from "../../components/common/VisibilityBox";

const ShopDetail = () => {
  const fUrl= process.env.REACT_APP_FILE_URL;
  const params = useParams();
  const navigate = useNavigate();
  const [employee, setEmployee] = useState<IShop>();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchDistributor();
  }, []);

  const fetchDistributor = async () => {
    try {
      const result = await getApi(ROUTES.SHOP_BY_ID + params?.id);
      setEmployee(result?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <div>
        <div className="d-flex">
          <button className="nav-link" onClick={() => navigate(-1)}>
                      <Icon icon="material-symbols:arrow-back-rounded" fontSize={25} />
                    </button>
          <h4 className="ms-2">Shop Detail</h4>
        </div>
        <section>
          <h5>{employee?.shopName}</h5>
          <div className="my-3">
  <div className="mb-3">
    <VisibilityBox show={employee?.displayImage !== ""}>
      <img
        src={fUrl + String(employee?.displayImage || "/images/store.png")}
        height={150}
        width={150}
        style={{ objectFit: "cover", borderRadius: "8px" }}
        alt="Shop"
      />
    </VisibilityBox>
  </div>

  <div className="table-responsive">
    <table className="table table-bordered table-striped">
      <tbody>
        <tr>
          <th>Shop Owner</th>
          <td>{employee?.shopOwner}</td>
        </tr>
        <tr>
          <th>Phone</th>
          <td>{employee?.shopContactNumber}</td>
        </tr>
        <tr>
          <th>Status</th>
          <td>{employee?.approved ? "Approved" : "Pending"}</td>
        </tr>
        <tr>
          <th>Shop Category</th>
          <td>{employee?.shopCategory}</td>
        </tr>
        <tr>
          <th>Shop Sub Category</th>
          <td>{employee?.shopSubCategory}</td>
        </tr>
        <tr>
          <th>Cooler Company</th>
          <td>{employee?.coolerCompany ? "Yes" : "No"}</td>
        </tr>
        <tr>
          <th>Cooler Self</th>
          <td>{employee?.coolerSelf ? "Yes" : "No"}</td>
        </tr>
        <tr>
          <th>Joint On</th>
          <td>{moment(employee?.createdAt).format("DD MMMM YYYY")}</td>
        </tr>
        <tr>
          <th>Address</th>
          <td>
            <div>{employee?.shopAddress}</div>
            <div>{employee?.shopArea}, {employee?.shopState}</div>
          </td>
        </tr>
        {Number(employee?.distributors?.length) > 0 && (
          <tr>
            <th>Distributors</th>
            <td>
              {employee?.distributors.map((distributor, index) => (
                <Fragment key={index}>
                  <Link
                    className="nav-link text-primary text-hover-underline"
                    to={`/distributors/${distributor}`}
                  >
                    View Distributor
                  </Link>
                </Fragment>
              ))}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</div>

        </section>
      </div>
    </>
  );
};

export default ShopDetail;
